import { WebSale } from '@/apps/shared/models/webSale';
import webSalesSettingService from '@/apps/shared/services/webSalesSettings-service';
import saveMultiQuoteNotificationsService from '@/apps/shared/services/saveMultiQuoteNotifications-service';
import { SaveMultiQuoteNotificationsRequest } from '../models/saveMultiQuoteNotificationsRequest';
import { safeRedirect } from '@/apps/shared/utils/safeRedirectHelper';
import chatBotService from '@/apps/shared/services/chatBot-service';

export default {
    // Función principal para personalizar la página
    async pageCustomization(
        route: any,
        Bus: any,
        store: any,
        defaultTitle: string,
        actualPath: string,
        actualStep: string | null,
        multiQuoteNotification: SaveMultiQuoteNotificationsRequest | null
    ): Promise<void> {

        let sessionUrl: string | null = null;
        const webSale: WebSale | null = store.getters.getWebSaleData;   // Accedemos a webSale a través del store pasado como argumento

        if (actualStep == 'tab-one' || actualStep == 'stepOffer') {
            await webSalesSettingService.initializeWebSales();
        }

        await this.checkExistWebSaleCustom().then(response => {
            sessionUrl = response.urlSite;
        });

        if (webSale && sessionUrl) {
            await this.updatePageCustomization(Bus, defaultTitle, store, actualStep, multiQuoteNotification);
        }
        else if (webSale && !sessionUrl) {
            await this.notifySessionExpiredAndRedirect(webSale, route, store);
        }
        else {
            // Si no existe webSale, chequeamos si hay subpath o sessionUrl
            await this.checkWebSale(route, Bus, defaultTitle, actualPath, store, actualStep, multiQuoteNotification, sessionUrl)
        }
    },

    // Notifica que la sesión expiró y sera redireccionado al home
    async notifySessionExpiredAndRedirect(webSale: WebSale, route: any, store: any): Promise<void> {
        NF.Notification.show({
            type: NF.Notification.Type.INFO,
            title: 'Info',
            content: 'Tu sesión ha expirado. Serás redirigido al inicio.',
            position: NF.Notification.Positions.BAR_TOP,
            clickClose: true,
            autoHideDelay: 10000,
        });
        store.dispatch('updateWebSaleData', null);
        setTimeout(async () => {
            sessionStorage.setItem("ExitOrContinueModal", "false");
            await safeRedirect(webSale.pageCustomization.navbar.logo.href, null, route);
        }, 5000);
    },

    // Verifica si existe un Web Sale Custom (con URL personalizada en la sesión)
    async checkWebSale(
        route: any,
        Bus: any,
        defaultTitle: string,
        actualPath: string,
        store: any,
        actualStep: string | null,
        multiQuoteNotification: SaveMultiQuoteNotificationsRequest | null,
        sessionUrl: string | null
    ): Promise<void> {
        const subpath = route.params.subpath;

        if (subpath) {
            if (actualStep == 'quoted' || actualStep == 'stepOffer') {
                actualPath = actualPath + "/elegiPlan";
            }
            await this.loadWebSaleSettings(subpath, actualPath, Bus, defaultTitle, store, actualStep, multiQuoteNotification);
        } else if (sessionUrl) {
            await this.loadWebSaleSettings(sessionUrl, actualPath, Bus, defaultTitle, store, actualStep, multiQuoteNotification);
        } else {
            await this.defaultPageCustomization(Bus, defaultTitle, store, actualStep);
        }
    },

    // Verifica si hay datos personalizados en la sesión
    async checkExistWebSaleCustom(): Promise<string | null> {
        const response: string | null = await webSalesSettingService.checkWebSalesSettings();
        return response;
    },

    // Carga los datos de la configuración de WebSale desde el servidor
    async loadWebSaleSettings(
        urlSite: string,
        actualPath: string,
        Bus: any,
        defaultTitle: string,
        store: any,
        actualStep: string | null,
        multiQuoteNotification: SaveMultiQuoteNotificationsRequest | null
    ): Promise<void> {
        const response = await webSalesSettingService.getWebSalesSettings(urlSite, actualPath);
        if (response) {
            store.dispatch('updateWebSaleData', response); // Actualizamos el estado de Vuex usando el store pasado como argumento
            await this.updatePageCustomization(Bus, defaultTitle, store, actualStep, multiQuoteNotification);
        } else {
            await this.defaultPageCustomization(Bus, defaultTitle, store, actualStep);
        }
    },

    // Actualiza la personalización de la página con los datos de WebSale
    async updatePageCustomization(
        Bus: any,
        defaultTitle: string,
        store: any,
        actualStep: string | null,
        multiQuoteNotification: SaveMultiQuoteNotificationsRequest | null
    ): Promise<void> {
        const webSale: WebSale | null = store.getters.getWebSaleData; // Accedemos al estado de Vuex a través del store pasado
        if (webSale && webSale.pageCustomization) {
            Bus.$emit('showNavbar', webSale.pageCustomization.navbar.active);
            Bus.$emit('updateLogo', webSale.pageCustomization.navbar.logo);
            Bus.$emit('updateTitle', webSale.pageCustomization.navbar.title);

            if (actualStep == 'quoted') {
                multiQuoteNotification.step = actualStep;
                await saveMultiQuoteNotificationsService.saveMultiQuoteNotifications(multiQuoteNotification);
            }

            sessionStorage.removeItem("isMulti");
            sessionStorage.setItem("isMulti", "true");
        } else {
            await this.defaultPageCustomization(Bus, defaultTitle, store, actualStep);
        }
    },

    // Si no existe personalización, usamos el título por defecto
    async defaultPageCustomization(
        Bus: any,
        defaultTitle: string,
        store: any,
        actualStep: string | null
    ): Promise<void> {
        Bus.$emit('updateTitle', defaultTitle);
        const siteCode = chatBotService.getSiteCodeByName(defaultTitle);
        if (siteCode) {
            Bus.$emit('show-chat', siteCode);
        }
        if (store.getters.getWebSaleData !== null) {
            store.dispatch('updateWebSaleData', null);
        }
        if (actualStep == 'tab-one' || actualStep == 'stepOffer') {
            await webSalesSettingService.cleanWebSalesSettings();
        }
    },

    deleteSessions() {
        webSalesSettingService.initializeWebSales();
        sessionStorage.clear();
    }
};
